import { useQuery } from "@tanstack/react-query"
import { auth } from "@shared/api/services"

export const useResetPasswordRequest = (data) => {
	return useQuery({
		queryKey: ['reset-password-request'],
		queryFn: () => auth.resetPasswordRequest({phone: data?.phone}),
		enabled: !!data?.phone && data.enabled,
		select: data => data.data,
  })
}